import styled from "styled-components";

import { down } from "styled-breakpoints";
import Typography from "src/components/atoms/Typography";
import IconButton from "src/components/atoms/IconButton";
import Layout from "src/components/Layout";
import { typographyCSS } from "src/components/atoms/Typography/styles";

interface WrapperProps {
  $src?: string;
}
export const Wrapper = styled.div<WrapperProps>`
  background: url(${({ $src }) => $src});
  background-color: ${({ theme }) => theme.palette.common.darkBlue};
  background-color: ${({ theme }) => theme.palette.common.darkBlue};
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  margin-top: 0px;
  margin-bottom: 0px;

  // transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
  padding: 5% 10% 5% 10%;
  position: relative;

  ${down("sm")} {
    padding: 2rem 0rem 2rem 0rem;
  }
`;

export const BackgroundOverlay = styled.div<WrapperProps>`
  background-color: ${({ theme }) => theme.palette.common.darkBlue};
  //background-image: url(/backgrounds/short_dark_01.svg);
  ////background-image: url(/backgrounds/short_dark_01.svg);
  background-position: top left;
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 0.9;
  transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  position: absolute;
  z-index: 2;
`;

export const Content = styled.div`
  position: relative;
  padding: 10px;
  z-index: 3;

  ${down("sm")} {
    width: 100%;
  }
`;

export const ContentInner = styled(Layout)`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.dark};
  padding-bottom: 36px;
  width: 100%;
  max-width: 900px;

  ${down("sm")} {
    width: 100%;
    max-width: 100%;
  }
`;

export const Title = styled(Typography).attrs({ variant: "h1" })`
  color: ${({ theme }) => theme.palette.common.white};
  padding: 0rem 0rem 2rem 0rem;
  text-align: center;
  ${down("sm")} {
    padding: 0rem 0rem 1rem 0rem;
  }
`;

export const SubTitle = styled(Typography).attrs({ variant: "body2" })`
  text-transform: none;
  color: ${({ theme }) => theme.palette.common.white};
  padding: 2rem 0rem 0rem 0rem;
  text-align: center;
  text-align: center;
  ${down("sm")} {
    padding: 1rem 0rem 0rem 0rem;
  }
`;

export const Meta = styled(Typography)`
  color: ${({ theme }) => theme.palette.common.white};
  ${typographyCSS("buttonMedium")}
  font-weight: 700;
  margin: 0;
  padding: 0;
  text-transform: uppercase;
  display: inline-flex;

  ${down("sm")} {
    text-align: center;
    display: block;
  }
`;

export const MetaInfo = styled.div`
  padding: 0rem 2rem;
  a {
    color: white;
  }

  &:not(:last-child) {
    border-style: solid;
    border-width: 0px 2px 0px 0px;
    border-color: white;
  }

  ${down("sm")} {
    border: none !important;
    padding: 0rem 3rem 0.5rem 3rem;
    margin: 0;
  }
`;

export const Bottom = styled.div`
  margin-top: 36px;
  position: relative;
  z-index: 3;
  ${down("sm")} {
    margin-top: 24px !important;
  }
`;

export const BottomInner = styled(Layout)`
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SocialContainer = styled(Layout)`
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ShareThisText = styled(Typography)`
  color: ${({ theme }) => theme.palette.common.white};
  ${typographyCSS("buttonMedium")}
  font-weight: 600;
  margin: 0rem 0rem 0rem 0rem;
  padding: 0rem 0rem 1rem 0rem;
  text-transform: uppercase;

  ${down("sm")} {
    padding: 0rem 0rem 1.5rem 0rem !important;
  }
`;

export const SocialIconButton = styled(IconButton)`
  width: 35px;
  height: 35px;
  border-radius: 100%;
  display: block;
  margin: 0 1rem 1rem 1rem;

  img {
    filter: brightness(200%) contrast(162%) saturate(200%) blur(0px)
      hue-rotate(40deg);
    padding: 0;

    display: block;

    ${down("sm")} {
      height: 70%;
      width: 70%;
    }
  }
`;
